import { render } from "./invitepullbackRia.vue?vue&type=template&id=a053a2b2"
import script from "./invitepullbackRia.vue?vue&type=script&lang=js"
export * from "./invitepullbackRia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__